import { render, staticRenderFns } from "./main-visual-body.vue?vue&type=template&id=796f5a48&scoped=true"
import script from "./main-visual-body.vue?vue&type=script&lang=js"
export * from "./main-visual-body.vue?vue&type=script&lang=js"
import style0 from "./main-visual-body.vue?vue&type=style&index=0&id=796f5a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f5a48",
  null
  
)

export default component.exports